import { Vehicle } from '@deliveries-app/models';
import { VehicleActions, VehicleActionTypes } from './actionTypes';

export interface VehiclesReducerState {
  loading: boolean;
  message: string;
  error: string;
  vehicles: Vehicle[];
}

const initialState: VehiclesReducerState = {
  loading: false,
  message: '',
  error: '',
  vehicles: [],
};

export default function vehiclesReducer(
  state = initialState,
  action: VehicleActions
): VehiclesReducerState {
  switch (action.type) {
    case VehicleActionTypes.VEHICLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case VehicleActionTypes.GET_ALL_VEHICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicles: action.payload,
        message: VehicleActionTypes.GET_ALL_VEHICLES_SUCCESS,
      };
    case VehicleActionTypes.GET_ALL_VEHICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
